//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'base-flash-notifications',
  computed: {
    ...mapGetters({
      flashMessages: 'notification/flashMessages',
    }),
    showFlashMessages() {
      return Array.isArray(this.currentFlashMessages) && this.currentFlashMessages.length;
    },
  },
  data() {
    return {
      currentFlashMessages: [],
    };
  },
  created() {
    // clone
    this.currentFlashMessages = this.flashMessages.slice();
    this.$store.dispatch('notification/clearFlashMessages');
  },
  methods: {
  },
  watch: {
    flashMessages(newMessages) {
      if (newMessages.length > 0) {
        this.currentFlashMessages = this.flashMessages.slice();
        this.$store.dispatch('notification/clearFlashMessages');
      }
    },
  },
};
